module.exports = __webpack_public_path__ + "img/top-contact.7a5c7efb.png";